import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/guide';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const sections = navLinks
      .map((link) => document.querySelector(link.href))
      .filter((el): el is Element => Boolean(el));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(`#${entry.target.id}`);
        });
      },
      { rootMargin: '-45% 0px -50% 0px', threshold: 0 },
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-md ${
              solid ? 'bg-accent-500 text-background-50' : 'bg-accent-500 text-background-50'
            }`}
          >
            <i className="ri-alarm-warning-line text-lg" aria-hidden="true" />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading font-bold text-lg tracking-wide ${
                solid ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              爆料51
            </span>
            <span
              className={`text-[10px] tracking-[0.2em] ${
                solid ? 'text-foreground-500' : 'text-background-200'
              }`}
            >
              投稿指南
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`px-3 py-2 text-sm rounded-md whitespace-nowrap transition-colors cursor-pointer ${
                active === link.href
                  ? solid
                    ? 'text-primary-700 bg-primary-100'
                    : 'text-primary-300 bg-background-50/10'
                  : solid
                    ? 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                    : 'text-background-100 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#submit"
            className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
          >
            <i className="ri-send-plane-fill" aria-hidden="true" />
            快速投稿
          </a>
          <button
            type="button"
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((prev) => !prev)}
            className={`lg:hidden w-9 h-9 flex items-center justify-center rounded-md cursor-pointer transition-colors ${
              solid ? 'text-foreground-900 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/10'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200">
          <nav className="px-4 py-3 flex flex-col" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 text-sm text-foreground-700 border-b border-background-100 last:border-0 cursor-pointer hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setMenuOpen(false)}
              className="mt-3 mb-1 py-3 text-center rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
            >
              快速投稿
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}